import script from "./CommisionSection7.vue?vue&type=script&setup=true&lang=js"
export * from "./CommisionSection7.vue?vue&type=script&setup=true&lang=js"

import "./CommisionSection7.vue?vue&type=style&index=0&id=bff67bda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bff67bda"]])

export default __exports__